import axios from 'axios';
import { baseUrl } from '@/config';

export default {
  /**
   * 맵 트리 데이터 조회
   * @author KangBonghun(toto1323)
   * @param  {Boolean} sortMode 맵 정렬 모드(true=모든 노드의 leaf를 false로 설정, false=자식 존재 여부에 따라 leaf 설정)
   * @return {[type]}        [description]
   */
  getTopologymapTree(sortMode) {
    return axios.get(`${baseUrl}/topologymap/get-topologymap-tree.do`, {
      params: {
        sortMode,
      },
    });
  },
  /**
   *  맵 트리 정렬 순서를 저장한다.
   * @author KangBonghun(toto1323)
   * @param  {Array} mapList 맵 모델 목록
   * @return {[type]}        [description]
   */
  updateTopologymapTreeOrder(mapList) {
    return axios.post(`${baseUrl}/topologymap/update-topologymap-tree-order.do`, mapList);
  },
  /**
   * 맵을 그리기 위해 특정 맵 데이터를 조회한다.
   * @author KangBonghun(toto1323)
   * @param  {Number} mapId   맵 아이디
   * @param  {Boolean} redirect 전달 받은 맵 아이디에 대한 권한이 없을 경우(true=권한이 있는 맵 중 첫번째 맵을 반환한다, false=Null을 반환한다)
   * @return {[type]}         [description]
   */
  getTopologymap(mapId, redirect, cancelToken) {
    return axios.get(`${baseUrl}/topologymap/get-topologymap.do`, {
      params: {
        mapId,
        redirect,
      },
      cancelToken,
    });
  },
  /**
   * 특정 맵 모델을 조회한다.
   * @author KangBonghun(toto1323)
   * @param  {Number} mapId 맵 아이디
   * @return {[type]}        [description]
   */
  getTopologymapModel(mapId) {
    return axios.get(`${baseUrl}/topologymap/get-topologymap-model.do`, {
      params: {
        mapId,
      },
    });
  },
  /**
   * 관리대상을 검색한다.
   * @author KangBonghun(toto1323)
   * @param  {[type]} mapId     맵 아이디
   * @param  {[type]} condition 검색어
   * @return {[type]}           [description]
   */
  getSearchObject(condition) {
    return axios.get(`${baseUrl}/topologymap/get-search-obj.do`, {
      params: {
        condition,
      },
    });
  },
  /**
   * 관리대상을 검색한다. +연결장비검색
   * @author KangBonghun(toto1323)
   * @param  {[type]} mapId     맵 아이디
   * @param  {[type]} condition 검색어
   * @return {[type]}           [description]
   */
  getSearchObject2(condition, type) {
    return axios.get(`${baseUrl}/topologymap/get-search-obj2.do`, {
      params: {
        condition,
        type,
      },
    });
  },
  /**
   * 검색한 관리대상이 포함된 맵 리스트를 조회한다.
   * @author KangBonghun(toto1323)
   * @param  {Number} mapId 맵 아이디
   * @param  {Number} objId 관리대상 아이디
   * @return {[type]}       [description]
   */
  getMaplistByObjId(objId) {
    return axios.get(`${baseUrl}/topologymap/get-maplist-by-objid.do`, {
      params: {
        objId,
      },
    });
  },
  /**
   * 검색한 자동맵 장비가 포함된 맵 리스트를 조회한다.
   * @author KangBonghun(toto1323)
   * @param  {[type]} ipaddress [description]
   * @return {[type]}           [description]
   */
  getMaplistByAutomapDevice(ipaddress) {
    return axios.get(`${baseUrl}/topologymap/get-maplist-by-automap-device.do`, {
      params: {
        ipaddress,
      },
    });
  },
  /**
   * 맵을 추가한다.
   * @author KangBonghun(toto1323)
   * @param  {Object} topologymap 맵 객체
   */
  addTopologymap(topologymap) {
    return axios.post(`${baseUrl}/topologymap/add-topologymap.do`, topologymap);
  },
  /**
   * 맵을 삭제한다.
   * @author KangBonghun(toto1323)
   * @param  {Object} mapId 맵 아이디
   * @return {[type]}        [description]
   */
  deleteTopologymap(mapId, includeAutomap) {
    return axios.get(`${baseUrl}/topologymap/delete-topologymap.do`, {
      params: {
        mapId,
        includeAutomap,
      },
    });
  },
  /**
   * 맵을 수정한다.
   * @author KangBonghun(toto1323)
   * @param  {Object} topologymapModel 맵 모델
   * @return {[type]}        [description]
   */
  updateTopologymap(topologymapModel) {
    return axios.post(`${baseUrl}/topologymap/update-topologymap.do`, topologymapModel, { timeout: 500000 });
  },
  /**
   * 맵에 그려진 오브젝트에 현재 발생한 이벤트를 조회한다.
   * @author KangBonghun(toto1323)
   * @param  {Number} mapId 맵 아이디
   * @return {[type]}       [description]
   */
  getEventInMap(mapId, cancelToken) {
    return axios.get(`${baseUrl}/topologymap/get-event-in-map.do`, {
      params: {
        mapId,
      },
      cancelToken,
    });
  },
  /**
   * 선택 된 오브젝트에 발생한 이벤트 목록을 조회한다.
   * @author KangBonghun(toto1323)
   * @param  {Number} elementId  요소아이디
   * @param  {String} objectType 요소타입 (ManagedObjectModel=관리대상, LanModel=회선, SubTopologymapModel=하위상황판, Custom1Model=사용자정의 위젯)
   * @return {[type]}            [description]
   */
  getElementEventList(elementId, objectType) {
    return axios.get(`${baseUrl}/topologymap/get-element-event-list.do`, {
      params: {
        elementId,
        objectType,
      },
    });
  },
  /**
   * 오브젝트의 툴팁 정보를 반환한다.
   * @author KangBonghun(toto1323)
   * @param  {Number}  elementId    오브젝트 요소 아이디
   * @param  {String}  managetypeId 관리구분 아이디
   * @param  {String}  objDefineId  관리대상 구분 아이디
   * @param  {Boolean} isLan        회선 여부
   * @return {[type]}               [description]
   */
  getTooltipInfo(elementId, managetypeId, objDefineId, objtypeId, isLan) {
    return axios.get(`${baseUrl}/topologymap/get-tooltip-info.do`, {
      params: {
        elementId,
        managetypeId,
        objDefineId,
        objtypeId,
        isLan,
      },
    });
  },
  /**
   * 가상객체 트리를 조회한다.
   * @author KangBonghun(toto1323)
   * @return {[type]} [description]
   */
  getVirtualObjectTree() {
    return axios.get(`${baseUrl}/topologymap/get-virtual-object-tree.do`);
  },
  /**
   * 슬라이드쇼 리스트를 반환한다.
   * @author KangBonghun(toto1323)
   * @return {[type]} [description]
   */
  getSlideshowList() {
    return axios.get(`${baseUrl}/topologymap/get-slideshow-list.do`);
  },
  /**
   * 슬라이드쇼를 추가한다.
   * @author KangBonghun(toto1323)
   * @param  {Object} slideshow 슬라이드쇼 모델
   */
  addSlideshow(slideshow) {
    return axios.post(`${baseUrl}/topologymap/add-slideshow.do`, slideshow);
  },
  /**
   * 슬라이드쇼를 삭제한다.
   * @author KangBonghun(toto1323)
   * @param  {Number} slideshowId 슬라이드쇼 아이디
   * @return {[type]}        [description]
   */
  deleteSlideshow(slideshowId) {
    return axios.get(`${baseUrl}/topologymap/delete-slideshow.do`, {
      params: {
        slideshowId,
      },
    });
  },
  /**
   * 슬라이드쇼를 수정한다.
   * @author KangBonghun(toto1323)
   * @param  {Array} slideshowList 슬라이드쇼 모델 목록
   * @return {[type]}        [description]
   */
  updateSlideshow(slideshowList) {
    return axios.post(`${baseUrl}/topologymap/update-slideshow.do`, slideshowList);
  },
  /**
   * 슬라이드쇼에 해당하는 슬라이드 리스트를 조회한다.
   * @author KangBonghun(toto1323)
   * @param  {Number} slideshowId 슬라이드쇼 아이디
   * @return {[type]}        [description]
   */
  getSlideList(slideshowId) {
    return axios.get(`${baseUrl}/topologymap/get-slide-list.do`, {
      params: {
        slideshowId,
      },
    });
  },
  /**
   * 슬라이드를 추가한다.
   * @author KangBonghun(toto1323)
   * @param  {Object} slide 슬라이드 모델
   */
  addSlide(slide) {
    return axios.post(`${baseUrl}/topologymap/add-slide.do`, slide);
  },
  /**
   * 슬라이드를 삭제한다.
   * @author KangBonghun(toto1323)
   * @param  {Number} slideshowId 슬라이드 아이디
   * @param  {Number} mapId 맵 아이디
   * @return {[type]}        [description]
   */
  deleteSlide(slideshowId, mapId) {
    return axios.get(`${baseUrl}/topologymap/delete-slide.do`, {
      params: {
        slideshowId,
        mapId,
      },
    });
  },
  /**
   * 슬라이드를 수정한다.
   * @author KangBonghun(toto1323)
   * @param  {Array} slideList 슬라이드 모델 목록
   * @return {[type]}        [description]
   */
  updateSlide(slideList) {
    return axios.post(`${baseUrl}/topologymap/update-slide.do`, slideList);
  },
  /**
   * 특정 네트워크 장비의 인터페이스 목록을 조회한다.
   * @author KangBonghun(toto1323)
   * @param  {Number} objId 네트워크 관리대상 아이디
   * @return {[type]}        [description]
   */
  getNetinerfaceList(objId) {
    return axios.get(`${baseUrl}/topologymap/get-netinterface-list.do`, {
      params: {
        objId,
      },
    });
  },
  /**
   * 사용자 이미지를 조회한다.
   * @author KangBonghun(toto1323)
   * @return {[type]} [description]
   */
  getCustomimage() {
    return axios.get(`${baseUrl}/topologymap/get-customimage.do`);
  },
  /**
   * 장비 정보를 조회한다.
   * @author KangBonghun(toto1323)
   * @param  {Number} objId 관리대상 아이디
   * @return {[type]}        [description]
   */
  getObjectInfo(objId) {
    return axios.get(`${baseUrl}/topologymap/get-obj-info.do`, {
      params: {
        objId,
      },
    });
  },
  /**
   * 장비 정보를 업데이트한다. 1) 중요도 2) 장비 상태 3) Active / Standby
   * @author KangBonghun(toto1323)
   * @param  {Object} objInfo [description]
   * @return {[type]}        [description]
   */
  updateObjectInfo(objInfo) {
    return axios.post(`${baseUrl}/topologymap/update-obj-info.do`, objInfo);
  },
  /**
   * 특정 맵에 속한 관리대상들의 범례,성능 정보를 조회한다.
   * @author KangBonghun(toto1323)
   * @param  {Number} mapId 맵 아이디
   * @return {[type]}        [description]
   */
  getObjResultInMap(mapId, cancelToken) {
    return axios.get(`${baseUrl}/topologymap/get-obj-result-in-map.do`, {
      params: {
        mapId,
      },
      cancelToken,
    });
  },
  /**
   * 특정 관리대상의 범례 정보를 조회한다.
   * @author KangBonghun(toto1323)
   * @param  {Number} objId 관리대상 아이디
   * @return {[type]}        [description]
   */
  getObjLegendByObj(objId) {
    return axios.get(`${baseUrl}/topologymap/get-obj-legend.do`, {
      params: {
        objId,
      },
    });
  },
  /**
   * 맵 화면을 캡쳐한다.
   * @author KangBonghun(toto1323)
   * @param  {Number} mapId  맵 아이디
   * @param  {String} base64 base64로 인코딩된 이미지
   * @return {[type]}        [description]
   */
  updateTopologymapCapture(mapId, base64) {
    return axios.post(`${baseUrl}/topologymap/update-topologymap-capture.do`, {
      mapId,
      base64,
    });
  },
  /**
   * 맵 미리보기 이미지를 조회한다.
   * @author KangBonghun(toto1323)
   * @param  {Number} mapId 맵 아이디
   * @return {[type]}        [description]
   */
  getMapPreview(mapId) {
    return axios.get(`${baseUrl}/topologymap/get-map-preview.do`, {
      params: {
        mapId,
      },
    });
  },
  /**
   * 맵 이름을 수정한다.
   * @author KangBonghun(toto1323)
   * @param  {Number} mapId   맵 아이디
   * @param  {String} mapName 맵 이름
   */
  updateTopologymapName(mapId, mapName) {
    return axios.get(`${baseUrl}/topologymap/update-topologymap-name.do`, {
      params: {
        mapId,
        mapName,
      },
    });
  },
  /**
   * 맵 화면의 확대/축소, 좌표 상태값을 저장한다.
   * @author KangBonghun(toto1323)
   * @param  {[type]} mapId 맵 아이디
   * @param  {[type]} x     x 좌표
   * @param  {[type]} y     y 좌표
   * @param  {[type]} scale 확대/축소 값
   * @return {[type]}       [description]
   */
  updateTopologymapViewStatus(mapId, x, y, scale) {
    return axios.get(`${baseUrl}/topologymap/update-topologymap-view-status.do`, {
      params: {
        mapId,
        x,
        y,
        scale,
      },
    });
  },
  /**
   * 이미지 그룹 리스트를 조회한다.
   * @author KangBonghun(toto1323)
   * @return {[type]} [description]
   */
  getCustomimageTypeList() {
    return axios.get(`${baseUrl}/topologymap/get-customimage-type-list.do`);
  },
  /**
   * 그룹별 이미지 리스트를 조회한다.
   * @author KangBonghun(toto1323)
   * @param  {Number} customimagetypeId 이미지그룹 아이디
   * @return {[type]}        [description]
   */
  getCustomimageList(customimagetypeId) {
    return axios.get(`${baseUrl}/topologymap/get-imagetype-customimage-list.do`, {
      params: {
        customimagetypeId,
      },
    });
  },
  /**
   * 장비제어를 위한 오브젝트 정보를 조회한다.
   * @author KangBonghun(toto1323)
   * @param  {[type]} objId 관리대상 아이디
   * @return {[type]}       [description]
   */
  getObjInfoForControl(objId) {
    return axios.get(`${baseUrl}/topologymap/get-objinfo-for-control.do`, {
      params: {
        objId,
      },
    });
  },
  /**
   * 관리자 접근 정보 팝업에서 텔넷 정보를 업데이트 한다.
   * @author KangBonghun(toto1323)
   * @param  {Number} objId 관리대상 아이디
   * @param  {String} telnetuserId1 텔넷유저아이디1
   * @param  {String} telnetuserPw1 텔넷유저비밀번호1
   * @param  {String} telnetuserId2 텔넷유저아이디2
   * @param  {String} telnetuserPw2 텔넷유저비밀번호2
   * @return {[type]}       [description]
   */
  updateAdminAccessInfo(objId, telnetuserId1, telnetuserPw1, telnetuserId2, telnetuserPw2) {
    return axios.post(`${baseUrl}/topologymap/update-admin-access-info.do`, {
      objId,
      telnetuserId1,
      telnetuserPw1,
      telnetuserId2,
      telnetuserPw2,
    });
  },
  /**
   * 맵 트리에서 숨길 맵 노드를 설정한다.
   * @author KangBonghun(toto1323)
   * @param  {Array} mapList 맵 모델 목록
   * @return {[type]}        [description]
   */
  updateTopologymapTreeHide(mapList) {
    return axios.post(`${baseUrl}/topologymap/update-topologymap-tree-hide.do`, mapList);
  },
  /**
   * 현재 맵의 타임라인 데이터를 조회한다.
   * @author vrax0343
   * @param  {Number} mapId 맵 아이디
   * @param  {Number} startDateTime 조회 시작 시간
   * @param  {Number} endDateTime 조회 끝 시간
   * @return {[type]}        [description]
   */
  getTimelineDataOfCurrentMap(dynamicParams, cancelToken) {
    return axios.post(`${baseUrl}/topologymap/get-timeline-data-of-current-map.do`, dynamicParams, {
      cancelToken,
    });
  },
  /**
   * 현재 맵의 맵 구성 현황 데이터를 조회한다.
   * @author vrax0343
   * @param  {Number} mapId 맵 아이디
   * @return {[type]}        [description]
   */
  getEventAndObjCountInMaps(mapId) {
    return axios.get(`${baseUrl}/topologymap/get-event-and-obj-count-in-map.do`, {
      params: {
        mapId,
      },
    });
  },
  /**
   * 장비주요정보 팝업 내용 조회
   * @author JungJiyoon(ryunnnne)
   * @param  {[type]} params [description]
   * @return {[type]}        [description]
   */
  getObjectMajorInfo(params) {
    return axios.post(`${baseUrl}/topologymap/get-object-major-info.do`, params);
  },
  /**
   E2E 대상일 경우 해당되는 에이전트의 정보 및 리스트를 조회
   * @author JungJiyoon(ryunnnne)
   * @param  {[type]} objId [description]
   * @return {[type]}       [description]
   */
  getAgentList(objId) {
    return axios.post(`${baseUrl}/topologymap/get-agent-list.do`, {
      objId,
    });
  },
  /**
   * 하위맵의 성능정보에서 쓰기 위한 성능/운영 요약의 root쪽 설정된 top5 자원정의를 조회
   * @author JungJiyoon(ryunnnne)
   * @return {[type]} [description]
   */
  getMgrSummaryInfo() {
    return axios.post(`${baseUrl}/topologymap/get-mgr-summary-info.do`, {});
  },
  getPerformanceGroupList(params) {
    return axios.post(`${baseUrl}/topologymap/get-performance-group-list.do`, params);
  },
  getPerformanceSensorGroupList(params) {
    return axios.post(`${baseUrl}/topologymap/get-sensor-performance-group-list.do`, params);
  },
  getPerformanceDatabaseGroupList(params) {
    return axios.post(`${baseUrl}/topologymap/get-database-performance-group-list.do`, params);
  },
  getPerformanceE2EGroupList(params) {
    return axios.post(`${baseUrl}/topologymap/get-e2e-performance-group-list.do`, params);
  },
  getPerformanceCommonListview(params) {
    return axios.post(`${baseUrl}/topologymap/get-performance-common-listview.do`, params);
  },
  getPerformanceServiceGroupList(params) {
    return axios.post(`${baseUrl}/topologymap/get-service-performance-group-list.do`, params);
  },
  getGroupPerformanceInfo(params) {
    return axios.post(`${baseUrl}/topologymap/get-group-performance-info.do`, params);
  },
  getSmsConfigInfoDeviceList(params) {
    return axios.post(`${baseUrl}/topologymap/get-sms-config-info-device-list.do`, params);
  },
  getCommonConfigInfoDeviceList(params) {
    return axios.post(`${baseUrl}/topologymap/get-common-config-info-device-list.do`, params);
  },
  getNetinterfaceConfigGroupList(params) {
    return axios.post(`${baseUrl}/topologymap/get-netinterface-group-config-list.do`, params);
  },
  getDbmsConfigInfoDeviceList(params) {
    return axios.post(`${baseUrl}/topologymap/get-dbms-config-info-device-list.do`, params);
  },
  getE2eConfigInfoDeviceList(params) {
    return axios.post(`${baseUrl}/topologymap/get-e2e-config-info-device-list.do`, params);
  },
  getSensorConfigInfoDeviceList(params) {
    return axios.post(`${baseUrl}/topologymap/get-sensor-config-info-device-list.do`, params);
  },
  getApmConfigInfoDeviceList(params) {
    return axios.post(`${baseUrl}/topologymap/get-apm-config-info-device-list.do`, params);
  },
  getServiceConfigInfoDeviceList(params) {
    return axios.post(`${baseUrl}/topologymap/get-service-config-info-device-list.do`, params);
  },
  getGroupConfigInfoForObjtype(params) {
    return axios.post(`${baseUrl}/topologymap/get-group-config-info-for-objtype.do`, params);
  },
  getNetdeviceConfigInfoDeviceList(params) {
    return axios.post(`${baseUrl}/topologymap/get-netdevice-config-info-device-list.do`, params);
  },
  getNetdeviceConfigInfoList(params) {
    return axios.post(`${baseUrl}/topologymap/get-netdevice-config-info-list.do`, params);
  },
  getNetdeviceRegularCheckDayList(params) {
    return axios.post(`${baseUrl}/topologymap/get-netdevice-regular-check-day-list.do`, params);
  },
  getNetdeviceRegularCheckList(params) {
    return axios.post(`${baseUrl}/topologymap/get-netdevice-regular-check-list.do`, params);
  },
  getNetdeviceDeviceViolationList(params) {
    return axios.post(`${baseUrl}/topologymap/get-netdevice-device-violation-list.do`, params);
  },
  getNetdevicePolicyViolationList(params) {
    return axios.post(`${baseUrl}/topologymap/get-netdevice-policy-violation-list.do`, params);
  },
  getNetdeviceConfigInfoDeviceAccountList(params) {
    return axios.post(`${baseUrl}/topologymap/get-netdevice-config-info-device-account-list.do`, params);
  },
  getObjCountForObjdefine(params) {
    return axios.post(`${baseUrl}/topologymap/get-obj-count-for-objdefine.do`, params);
  },
  getEventStatusList(params) {
    return axios.post(`${baseUrl}/topologymap/get-event-status-list.do`, params);
  },
  getEventHistList(params) {
    return axios.post(`${baseUrl}/topologymap/get-event-hist-list.do`, params);
  },
  getEventHistChartData(params) {
    return axios.post(`${baseUrl}/topologymap/get-event-hist-chart-data.do`, params);
  },
  getTroubleShootingList(params) {
    return axios.post(`${baseUrl}/topologymap/get-trouble-shooting-list.do`, params);
  },
  getPredictEventHist(params) {
    return axios.post(`${baseUrl}/topologymap/get-predict-event-hist.do`, params);
  },
  getEventStatusExcelName(params) {
    return axios.post(`${baseUrl}/topologymap/get-event-status-excel-name.do`, params);
  },
  getEventHistExcelName(params) {
    return axios.post(`${baseUrl}/topologymap/get-event-hist-excel-name.do`, params);
  },
  getNetdeviceConfigInfoDeviceListExcelName(params) {
    return axios.post(`${baseUrl}/topologymap/get-netdevice-config-info-device-list-excel-name.do`, params);
  },
  getNetdeviceConfigInfoConfigListExcelName(params) {
    return axios.post(`${baseUrl}/topologymap/get-netdevice-config-info-config-list-excel-name.do`, params);
  },
  getNetdeviceRegularCheckListExcelName(params) {
    return axios.post(`${baseUrl}/topologymap/get-netdevice-regular-check-list-excel-name.do`, params);
  },
  getNetdeviceConfigInfoDeviceAccountListExcelName(params) {
    return axios.post(`${baseUrl}/topologymap/get-netdevice-config-info-device-account-list-excel-name.do`, params);
  },
  getSmsConfigInfoDeviceListExcelName(params) {
    return axios.post(`${baseUrl}/topologymap/get-sms-config-info-device-list-excel-name.do`, params);
  },
  getCommonConfigInfoDeviceListExcelName(params) {
    return axios.post(`${baseUrl}/topologymap/get-common-config-info-device-list-excel-name.do`, params);
  },
  getNetinterfaceConfigGroupListExcelName(params) {
    return axios.post(`${baseUrl}/topologymap/get-netinterface-config-group-list-excel-name.do`, params);
  },
  getApmDeviceExcelName(params) {
    return axios.post(`${baseUrl}/topologymap/get-apm-device-excel-name.do`, params);
  },
  getSensorConfigInfoDeviceListExcelName(params) {
    return axios.post(`${baseUrl}/topologymap/get-sensor-config-info-device-list-excel-name.do`, params);
  },
  getDbmsConfigInfoDeviceListExcelName(params) {
    return axios.post(`${baseUrl}/topologymap/get-dbms-config-info-device-list-excel-name.do`, params);
  },
  getExportE2eConfigInfoDeviceListExcelName(params) {
    return axios.post(`${baseUrl}/topologymap/get-export-e2e-config-info-device-list-excel-name.do`, params);
  },
  getExportServiceConfigInfoDeviceListExcelName(params) {
    return axios.post(`${baseUrl}/topologymap/get-export-service-config-info-device-list-excel-name.do`, params);
  },
  getVmsConfigInfoTargetDeviceListExcelName(params) {
    return axios.post(`${baseUrl}/topologymap/get-vms-config-info-target-device-list-excel-name.do`, params);
  },
  getTroubleShootingExcelName(params) {
    return axios.post(`${baseUrl}/topologymap/get-trouble-shooting-excel-name.do`, params);
  },
  getPredictEventInfoExcelName(params) {
    return axios.post(`${baseUrl}/topologymap/get-predict-event-info-excel-name.do`, params);
  },
  /**
   * 장비 연결정보 조회
   * @author KangBonghun(toto1323)
   * @param  {[type]} ipaddressList [description]
   * @return {[type]}           [description]
   */
  getConnectInfo(ipaddressList) {
    return axios.post(`${baseUrl}/topologymap/get-connect-info.do`, ipaddressList);
  },
  /**
   * 장비 정보 조회
   * @author KangBonghun(toto1323)
   * @param  {[type]} ipaddressList [description]
   * @return {[type]}           [description]
   */
  getObjInfoList(ipaddressList) {
    return axios.post(`${baseUrl}/topologymap/get-obj-info-list.do`, ipaddressList);
  },
  getMgrTopologymap(mapId) {
    return axios.get(`${baseUrl}/topologymap/get-mgr-topologymap.do`, {
      params: {
        mapId,
      },
    });
  },
  /**
   * 이벤트 등급 별 이벤트 이력 통계 데이터를 조회한다.
   * @author JH(leejh55)
   */
  getEventHistStatsGroupByEventlevel(params) {
    return axios.post(`${baseUrl}/topologymap/get-event-hist-count-by-eventlevel.do`, params);
  },
  /**
   * 관리 구분(obj_define) 별 이벤트 이력 통계 데이터를 조회한다.
   * @author JH(leejh55)
   * @param  {[type]} objIdList [description]
   * @return {[type]}           [description]
   */
  getEventHistStatsGroupByObjDefine(params) {
    return axios.post(`${baseUrl}/topologymap/get-event-hist-count-by-obj-define.do`, params);
  },
  /**
   * 장비 별 이벤트 이력 TopN 이벤트 등급 통계를 조회한다.
   * @author JH(leejh55)
   * @param  {[type]} objIdList [description]
   * @return {[type]}           [description]
   */
  getEventHistStatsGroupByObjTopN(params) {
    return axios.post(`${baseUrl}/topologymap/get-event-hist-count-by-obj-top-n.do`, params);
  },
  /**
   * 자동맵의 장비주요정보 팝업 내용 조회
   * @author JungJiyoon(ryunnnne)
   * @param  {[type]} params [description]
   * @return {[type]}        [description]
   */
  getAutoMapObjectMajorInfo(params) {
    return axios.post(`${baseUrl}/topologymap/get-automap-object-major-info.do`, params);
  },
  getAutoTopologyScheduleInfo(scheduleId) {
    return axios.get(`${baseUrl}/topologymap/get-autotopology-schedule-info.do`, {
      params: {
        scheduleId,
      },
    });
  },
  updateAutomapDeviceConfigInfo(params) {
    return axios.post(`${baseUrl}/topologymap/update-automap-device-config-info.do`, params);
  },
  updateAutomapInterfaceConfigInfo(params) {
    return axios.post(`${baseUrl}/topologymap/update-automap-interface-config-info.do`, params);
  },
  getAutomapDeviceList(params) {
    return axios.post(`${baseUrl}/topologymap/get-automap-device-list.do`, params);
  },
  /**
   * 하위맵에 연결관계 맵이 존재하는지 여부 조회
   * @author KangBongHun(toto1323)
   * @param  {[type]} mapId [description]
   * @return {[type]}       [description]
   */
  checkIncludeAutomap(mapId) {
    return axios.get(`${baseUrl}/topologymap/check-include-automap.do`, {
      params: {
        mapId,
      },
    });
  },
  /**
   * 연결정보 수집 스케줄을 즉시 수행한다.
   * @author KangBongHun(toto1323)
   * @param  {[type]} scheduleId [description]
   * @return {[type]}       [description]
   */
  executeAutomapSchedule(scheduleId) {
    return axios.get(`${baseUrl}/topologymap/execute-automap-schedule.do`, {
      params: {
        scheduleId,
      },
    });
  },
  /**
   * 자동맵(연결관계) 정보 조회
   * @author KangBongHun(toto1323)
   * @param  {[type]} params [description]
   * @return {[type]}        [description]
   */
  getAutotopologyInfo(params) {
    return axios.get(`${baseUrl}/topologymap/get-autotopology-info.do`, { params });
  },
  /**
   * 연결정보 수집 진행률 조회
   * @author KangBongHun(toto1323)
   * @param  {[type]} scheduleId [description]
   * @return {[type]}            [description]
   */
  getAutotopologyExecProgressRate(scheduleId) {
    return axios.get(`${baseUrl}/topologymap/get-autotopology-exec-progress-rate.do`, {
      params: {
        scheduleId,
      },
    });
  },
};



// WEBPACK FOOTER //
// ./src/api/topologymap/common.js